import React from "react";
const Booking = () => {
  return <></>;
};

export default Booking;
